import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { ImpersonationService } from 'app/modules/team/services/impersonation.service';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { AuthUtils } from 'app/core/auth/auth.utils';

@Component({
  selector: 'impersonation-banner',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslocoModule],
  template: `
    <div *ngIf="isImpersonating" 
         class="sticky top-0 z-50 flex flex-col sm:flex-row items-center justify-between w-full py-2 px-3 sm:px-6 bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-md">
      <div class="flex items-center mb-2 sm:mb-0">
        <div class="flex items-center justify-center bg-white bg-opacity-20 rounded-full p-1 mr-3">
          <mat-icon class="text-white">account_circle</mat-icon>
        </div>
        <span class="text-sm sm:text-base font-medium">
          {{ ('impersonation.message' | transloco).replace('{username}', user.email) }}
        </span>
      </div>
      <button
        mat-raised-button
        color="warn"
        class="min-w-32 py-1 px-3 text-sm shadow-sm hover:shadow-lg transition-all duration-200 ease-in-out"
        (click)="endImpersonation()">
        <mat-icon class="mr-1">exit_to_app</mat-icon>
        <span>{{ 'impersonation.exit' | transloco }}</span>
      </button>
    </div>
  `
})
export class ImpersonationBannerComponent implements OnInit, OnDestroy {
  isImpersonating: boolean = false;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  user: any;
  constructor(private impersonationService: ImpersonationService) {}

  ngOnInit(): void {
    // Check initial impersonation state
    this.isImpersonating = this.impersonationService.isImpersonating();
    this.user = AuthUtils.getUserToken();
    
    // Listen for changes to impersonation state in real-time
    this.impersonationService.impersonationState$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((isImpersonating: boolean) => {
        this.isImpersonating = isImpersonating;
        if (isImpersonating) {
          this.user = AuthUtils.getUserToken();
        }
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  /**
   * End the impersonation session
   */
  endImpersonation(): void {
    this.impersonationService.endImpersonation()
      .subscribe(() => {
        // The state will be updated automatically via the BehaviorSubject
        // No need to manually set isImpersonating = false
      });
  }
} 